<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" :footer-hide="detail" width="80%">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="130">

            <Row>
                <Col span="8">
                    <FormItem label="检测车辆" prop="plateNo" :rules="[rules.required]">
                        <Input v-model="formData.plateNo" placeholder="车牌号或环保登记号码" style="width:200px;"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="检测类型" prop="assayType" :rules="[rules.requiredNumber]">
                        <Select v-model="formData.assayType" placeholder="检测类型" style="width:200px;">
                            <Option :value="0">在用</Option>
                            <Option :value="1">新生产</Option>>
                            <Option :value="2">进口</Option>>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="检测单位" prop="department.id" :rules="[rules.requiredNumber]">
                        <depart-sel v-model="formData.department.id" placeholder="检测单位" :departmentType="1" width="200px"></depart-sel>
                    </FormItem>
                </Col>
            </Row>
            <Row v-show="formData.id == null">
                <Col span="8">
                    <FormItem label="烟度计" prop="opacimeterId">
                        <instrument-sel v-model="formData.opacimeterId" placeholder="烟度计" :departmentId="formData.department.id" :dataType="1"></instrument-sel>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="计时器" prop="timerId">
                        <instrument-sel v-model="formData.timerId" placeholder="计时器" :departmentId="formData.department.id" :dataType="2"></instrument-sel>
                    </FormItem>
                </Col>
            </Row>
            <Row v-show="formData.id == null">
                <Col span="8">
                    <FormItem label="转速分析仪" prop="vsaId">
                        <instrument-sel v-model="formData.vsaId" placeholder="转速分析仪" :departmentId="formData.department.id" :dataType="3"></instrument-sel>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="滤光片" prop="lightfilterId">
                        <instrument-sel v-model="formData.lightfilterId" placeholder="滤光片" :departmentId="formData.department.id" :dataType="4"></instrument-sel>
                    </FormItem>
                </Col>
            </Row>
            <Row v-show="formData.id != null">
                <Col span="8">
                    <FormItem label="烟度计">
                        <Input :value="formData.opacimeterType?(formData.opacimeterType+'-'+formData.opacimeterNo):''" style="width:200px;"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="计时器">
                        <Input :value="formData.timerType?(formData.timerType+'-'+formData.timerNo):''" style="width:200px;"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row v-show="formData.id != null">
                <Col span="8">
                    <FormItem label="转速分析仪">
                        <Input :value="formData.vsaType?(formData.vsaType+'-'+formData.vsaNo):''" style="width:200px;"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="滤光片">
                        <Input :value="formData.lightfilterType?(formData.lightfilterType+'-'+formData.lightfilterNo):''" style="width:200px;"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="环境温度" prop="temperature">
                        <InputNumber v-model="formData.temperature" placeholder="环境温度"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="湿度" prop="elevation">
                        <InputNumber v-model="formData.humidity" placeholder="湿度"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="海拔高度" prop="elevation">
                        <InputNumber v-model="formData.elevation" placeholder="海拔高度"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="大气压力" prop="pressure">
                        <InputNumber v-model="formData.pressure" placeholder="大气压力"></InputNumber>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="测量值1" prop="smokeVal1" :rules="[rules.requiredNumber]">
                        <InputNumber v-model="formData.smokeVal1" @on-change="calSmokeVal"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="测量值2" prop="smokeVal2" :rules="[rules.requiredNumber]">
                        <InputNumber v-model="formData.smokeVal2" @on-change="calSmokeVal"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="测量值3" prop="smokeVal3" :rules="[rules.requiredNumber]">
                        <InputNumber v-model="formData.smokeVal3" @on-change="calSmokeVal"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="平均值" prop="smokeVa">
                        <Input type="number" v-model="formData.smokeVal" :disabled="true"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="最大值" prop="maxVal">
                        <Input type="number" :value="maxVal" :disabled="true"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="实测转速" prop="realSpeed">
                        <InputNumber v-model="formData.realSpeed"></InputNumber>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="目视烟羽" prop="visualPlume">
                        <RadioGroup v-model="formData.visualPlume">
                            <Radio :label="0">不可见</Radio>
                            <Radio :label="1">可见</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
            </Row>

            <Row>
                <Col span="7">
                    <FormItem label="检测方法" prop="examMethod" :rules="[rules.requiredNumber]">
                        <Select v-model="formData.examMethod" placeholder="检测方法" style="width:200px;">
                            <Option :value="0">自由加速法</Option>
                            <Option :value="1">自由加载法</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem label="检测日期" prop="examDate" :rules="[rules.required]">
                        <DatePicker type="date" placeholder="检测日期" format="yyyy-MM-dd" :value="formData.examDate" @on-change="examChange"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem label="检测时间">
                        <TimePicker type="timerange" placeholder="检测时间" :value="examTime" @on-change="examTimeChange"></TimePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="检测地址" prop="examAddress" :rules="[rules.required]">
                        <Input placeholder="检测地址" v-model="formData.examAddress"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="定位终端" prop="contactAddress">
                        <Input placeholder="定位终端" v-model="formData.contactAddress"></Input>
                    </FormItem>
                </Col>
            </Row>

            <Row>
                <Col span="6">
                    <FormItem label="机械照片(侧面45度)">
                        <do-picture v-model="formData.pic1"></do-picture>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="机械铭牌照片">
                        <do-picture v-model="formData.pic2"></do-picture>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="发动机铭牌照片">
                        <do-picture v-model="formData.pic4"></do-picture>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="环保信息标签照片">
                        <do-picture v-model="formData.pic3"></do-picture>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="检测视频">
                        <do-video v-model="formData.video"></do-video>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="检测结果扫描图片">
                        <do-picture v-model="formData.scanPic"></do-picture>
                    </FormItem>
                </Col>
            </Row>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit">确定</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import modalHelper from "@/mixins/modalHelper";
    import rules from '@/libs/rules';
    import DoPicture from '_c/auto-form/DoPicture';
    import DoVideo from '_c/auto-form/DoVideo';
    import DepartSel from '@/module/main/components/DepartSel';
    import InstrumentSel from '@/module/main/components/InstrumentSel';
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        reportNo:null,
        reportUuid:null,
        department:{id:null},
        plateNo:null,
        equipmentId:null,
        archiveInfo:null,
        assayType:0,
        perfermance:0,
        highDis:1,
        opacimeterType:null,
        opacimeterNo:null,
        opacimeterManu:null,
        timerType:null,
        timerNo:null,
        timerManu:null,
        vsaType:null,
        vsaNo:null,
        vsaManu:null,
        lightfilterType:null,
        lightfilterNo:null,
        lightfilterManu:null,
        temperature:null,
        elevation:null,
        pressure:null,
        humidity:null,
        examMethod:0,
        smokeVal1:null,
        smokeVal2:null,
        smokeVal3:null,
        smokeVal:null,
        pic1:null,
        pic2:null,
        pic3:null,
        pic4:null,
        scanPic:null,
        examDate:null,
        expireDate:null,
        examAddress:null,
        contactAddress:null,
        realSpeed:null,
        status:0,
        opacimeterId:null,
        timerId:null,
        vsaId:null,
        lightfilterId:null,
        video:null,
        startTime:null,
        endTime:null,
        visualPlume:0
    };

    export default {
        name: "report-edit",
        mixins: [modalHelper],
        components: {
            DoPicture,DepartSel,InstrumentSel,DoVideo
        },
        props:{
            equipId:{
                type:Number,
                default:0
            },
            detail:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                rules,
                formData: _don.cloneWithModal(formModal),
                title:'添加检测报告',
                upOption:{uploadMaxCount:3},
                examTime:[null, null]
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);

                let startTime = ''
                let endTime = ''
                if (this.dataSource.startTime){
                    startTime = this.dataSource.startTime.substr(11,8)
                }
                if (this.dataSource.endTime){
                    endTime = this.dataSource.endTime.substr(11,8)
                }
                this.examTime = [startTime, endTime]
            },
            async handleSubmit() {
                if (!await this.$refs.form.validate()) return;
                if (this.examTime.length < 2 || !this.examTime[0] || !this.examTime[1]) {
                    this.$Message.error('请选择检测时间')
                    return
                }
                this.formData.startTime = this.formData.examDate + ' ' + this.examTime[0]
                this.formData.endTime = this.formData.examDate + ' ' + this.examTime[1]
                this.formData.equipmentId = this.equipId;
                // 提交
                iEquip.reportAdd(this.formData).then(() => {
                    this.$Message.success('操作成功');
                    this.$emit('on-success', this.formData);
                    this.currValue = false;
                }).loadingSwitch(this, 'loading');
            },
            examChange(v) {
                this.formData.examDate = v
            },
            examTimeChange(v) {
                let startTime = ''
                let endtime = ''
                v.length>0&&(startTime=v[0])
                v.length>1&&(endtime=v[1])
                this.examTime = [startTime, endtime]
            },
            calSmokeVal(){
                let v = 0
                let num = 0
                if(this.formData.smokeVal1){
                    v = v + this.formData.smokeVal1
                    num++
                }
                if(this.formData.smokeVal2){
                    v = v + this.formData.smokeVal2
                    num++
                }
                if(this.formData.smokeVal3){
                    v = v + this.formData.smokeVal3
                    num++
                }
                if(num > 0){
                    this.formData.smokeVal = this.parseMinus2(v/num)
                }
            },
            parseMinus2(val){
                if(isNaN(val)){
                    return 0
                }
                return Math.round(val*100)/100
            }
        },
        computed: {
            maxVal(){
                let v = 0
                if(this.formData.smokeVal1){
                    v = this.formData.smokeVal1 > v ? this.formData.smokeVal1 : v
                }
                if(this.formData.smokeVal2){
                    v = this.formData.smokeVal2 > v ? this.formData.smokeVal2 : v
                }
                if(this.formData.smokeVal3){
                    v = this.formData.smokeVal3 > v ? this.formData.smokeVal3 : v
                }
                return v
            },
        },
        watch:{

        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
